import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {Group} from '../../../graphql/groups.datatypes';

interface GroupsData {
    myGroups: void
    groups: {
        data: Group[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const gqlGroupsGroup = `
  id
  name
  start_date
  end_date
  cost
  outstandingBalance
  overduePayments
  booking_form_url

  tour {
    id
    internal_name
    display_name
  }
  hotel {
    id
    internal_name
    display_name
  }
  members {
    id
  }
  active_members {
    id
  }
`;

export const GET_GROUPS_QUERY = gql`
  query groups($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
    groups(first: $count, page: $page, where: $where, orderBy: $orderBy){
      data {
        ${gqlGroupsGroup}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getGroups = (count: number, page: number, where?: any, orderBy?: any) => useQuery<GroupsData>(
  GET_GROUPS_QUERY,
  {
    variables: {
      count,
      page,
      where,
      orderBy,
    },

  }
);

export default getGroups;
